import { CUSTOM_BIOME_THEME } from "@/constants";
import { onDarkBase } from "@biom3/design-tokens";
import { createTheme } from "@mui/material/styles";
import type { ThemeOptions } from "@mui/material/styles";
import getComponentsOverrides from "./overrides";
import { typography } from "./typography";

export const themeOptions: ThemeOptions = {
  ...CUSTOM_BIOME_THEME,
  palette: {
    mode: "dark",
    text: {
      primary: onDarkBase.color.brand[1],
      secondary: onDarkBase.color.brand[4],
    },
    background: {
      paper: onDarkBase.color.neutral[500],
    },
    info: {
      main: onDarkBase.color.status.guidance.bright,
    },
    success: {
      main: onDarkBase.color.status.success.bright,
    },
    primary: {
      main: onDarkBase.color.brand[1],
    },
  },
  typography,
};

const theme = createTheme(themeOptions);

theme.components = getComponentsOverrides(theme);

export default theme;
